import HeadDetailsGama from '@/views/private/realestate/components/HeadDetails.vue'
import { toast, loading } from '@/shared/utils/UIHelper'
import state from '@/shared/http/repositories/geo/state'
import usermanagement from '@/shared/http/repositories/realestate/usermanagement'
import {mask} from 'vue-the-mask'
import axios from 'axios'

export default{
  components: {
    HeadDetailsGama
  },
  props: {
    showFrame: {
      type: Boolean,
      default: false
    },
    editCustomer: {
      type: Boolean,
      default: false
    },
    showCreci: {
      type: Boolean,
      default: true
    },
    editUserData: {
      type: Object,
      default: {}
    },
    corretor: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      statesAcronym: [],
      activeUser: this.editUserData.status === 0
    }
  },
  mounted () {
    state.GetAllByCountryID('2375E209-7451-4A7A-A9BE-66BD2C392BE1')
      .then((res) => {
        let stateCompleteData = res.data.data
        stateCompleteData.forEach(stateData => {
          this.statesAcronym.push({value: stateData.id, text: stateData.sigla})
        })
      })
      .catch(() => {})
  },
  methods: {
    validateState (ref) {
      if (this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated)) {
        if (this.errors.has(ref)) {
          return false
        }
      }
      return null
    },
    openModal (modalRef) {
      this.$refs[modalRef].show()
    },
    closeModal (modalRef) {
      this.$refs[modalRef].hide()
    },
    openNotice () {
      this.$refs['reset-password-modal'].hide()
      this.$refs['reset-password-notice'].show()
    },
    backPage (e) {
      e.preventDefault()
      this.$emit('updateView', false)
    },
    onSubmit (e) {
      e.preventDefault()
      this.$validator.validateAll().then(result => {
        if (!result) {
          return
        }
        let sendData = {}

        Object.assign(sendData, this.editUserData)
        sendData.id = this.editUserData.id
        sendData.cpf = sendData.cpf.replace(/[().-]/gm, '')
        sendData.celular = sendData.celular.replace(/[().-]/gm, '')
        sendData.telefoneComercial = sendData.telefoneComercial.replace(/[().-]/gm, '')
        sendData.cep = sendData.cep.replace(/[().-]/gm, '')
        if (this.editCustomer) {
          usermanagement.PutCliente(sendData)
            .then(res => {
              if (res.status === 200) {
                this.closeModal('approve-user-modal')
                toast.success(`Alterações salvas com sucesso`)
                this.$emit('updateView', false)
                loading.pop()
              }
            })
            .catch(() => {
              toast.error(`Erro ao salvar mudanças`)
              loading.pop()
            })
        } else {
          usermanagement.PutCorretor(sendData)
            .then(res => {
              if (res.status === 200) {
                this.closeModal('approve-user-modal')
                toast.success(`Alterações salvas com sucesso`)
                this.$emit('updateView', false)
                loading.pop()
              }
            })
            .catch(() => {
              toast.error(`Erro ao salvar mudanças`)
              loading.pop()
            })
        }
      })
    },
    deleteUser () {
      if (this.editCustomer) {
        usermanagement.DeleteCliente(this.editUserData.id)
          .then(res => {
            if (res.status === 200) {
              toast.success(`Cliente excluido com sucesso`)
              loading.pop()
              this.$emit('updateView', false)
            }
          })
          .catch(() => {
            toast.success(`Erro ao excluir cliente`)
            loading.pop()
          })
        return
      }
      usermanagement.DeleteCorretor(this.editUserData.id)
        .then(res => {
          if (res.status === 200) {
            toast.success(`Corretor excluido com sucesso`)
            loading.pop()
            this.$emit('updateView', false)
          }
        })
        .catch(() => {
          toast.success(`Erro ao excluir usuário`)
          loading.pop()
        })
    },
    inactivateUser () {
      if (this.editCustomer) {
        usermanagement.TrocarStatusCliente(this.editUserData.id)
          .then(res => {
            if (res.status === 200) {
              toast.success(`Status do cliente trocado com sucesso`)
              loading.pop()
              this.$emit('updateView', false)
            }
          })
          .catch(() => {
            toast.error(`Erro ao trocar status do cliente`)
            loading.pop()
          })
        return
      }
      usermanagement.TrocarStatusCorretor(this.editUserData.id)
        .then(res => {
          if (res.status === 200) {
            toast.success(`Status do corretor alteradado com sucesso`)
            loading.pop()
            this.$emit('updateView', false)
          }
        })
        .catch(() => {
          toast.error(`Erro ao trocar status do corretor`)
          loading.pop()
        })
    },
    searchAndress () {
      axios({
        method: 'GET',
        url: `https://viacep.com.br/ws/${this.editUserData.cep}/json/`
      }).then(res => {
        if (!('erro' in res.data)) {
          let data = res.data
          if (res.status === 200) {
            this.editUserData.cidade = data.localidade
            this.editUserData.endereco = data.logradouro
            this.editUserData.bairro = data.bairro
          }
        }
      })
        .catch(() => {})
    },
    approveReproveUser (approve) {
      usermanagement.AprovarReprovarCorretor(this.editUserData.id, approve)
        .then(res => {
          if (res.status === 200) {
            this.closeModal('approve-user-modal')
            toast.success(`Usuário ${approve ? 'aprovado' : 'reprovado'} com sucesso`)
            loading.pop()
            this.$emit('updateView', false)
          }
        })
        .catch(() => {
          toast.error(`Erro ao ${approve ? 'aprovar' : 'reprovar'} usuário`)
          loading.pop()
        })
    },
    resetPassword () {
      if (this.editCustomer) {
        usermanagement.ResetSenhaCliente(this.editUserData.id)
          .then(res => {
            if (res.status === 200) {
              this.openNotice()
              toast.success(`Senha resetada com sucesso`)
              loading.pop()
            }
          })
          .catch((e) => {
            toast.error(e`Erro ao resetar senha`)
            loading.pop()
          })
        return
      }
      usermanagement.ResetSenhaCorretor(this.editUserData.id)
        .then(res => {
          if (res.status === 200) {
            this.openNotice()
            toast.success(`Senha resetada com sucesso`)
            loading.pop()
          }
        })
        .catch(() => {
          toast.error(`Erro ao resetar senha`)
          loading.pop()
        })
    }
  },
  directives: {mask}
}



// WEBPACK FOOTER //
// ./src/views/private/realestate/users/components/UserEditForm/UserEditForm.js